import { useEffect, useState } from "react";
import { getTopper } from "../Service/Api";
import Slider from "react-slick";
import LazyLoad from "react-lazyload";
const Topper = () => {
  const [data, setData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const messages = await getTopper();
      setData(messages);
    };
    fetchData();
  }, []);
  const emptyArray = [
    // { description: "“Educating the mind without educating the heart is no education at all.” Sacred Heart has been educating boys and girls since 1990; though much has changed over the years our mission remains the same. Sacred Heart is committed to developing students of high academic achievement, intellectual curiosity, and strong moral character. As a result, year after year Sacred Heart sends our respectful, responsible and compassionate young adults, who are well prepared to tackle the challenges that lay ahead. Since arriving at Sacred Heart in 2016, I have had the opportunity to observe this unique institution up close. I have seen its commitment to academic excellence, its dynamic student body, and incredibly committed faculty and a loving community where the students and families are proud and supportive of one another. As I walk down the hallways of the school every day, I can hear the chatter of eager minds; the shouts of excitement from the victorious athletes, the thumb of dancers feed and the sound of melodious voices harmonizing the perpetual energy, movement and enthusiasm permeate the atmosphere. Ours is a school with difference. We value creativity and innovation and strive to nurture them in our students. Sacred Heartians are groomed to become confident, articulate and enlightened young citizens ready to step into the global society with dignity, honour and integrity. Aristotle once said “Educating the mind without educating the heart is no education at all”. Even as we impart education to match the advancement in technology and globalization, we march our children ahead with Sacred Heart ethos of moral values and principles. We Endeavour constantly to instill these qualities in our children. We pride ourselves to help them grow and develop into sensitive, responsible God loving citizens of the future. May the Sacred Heart of Jesus bless us abundantly in all our endeavourers.", attachments: "director.jpg" },
  ];

  var settings = {
    autoplay: true,
    infinite: true,
    autoplaySpeed: 2000,
    speed: 1000,
    slidesToShow: 5,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <>
      <div className="row">
        <Slider {...settings}>
          {data?.length > 0
            ? data
                ?.filter((div) => div.class === "X")
                .map((item, index) => (
                  <div className="item" key={index}>
                    <div className="topperdiv">
                      <div className="topperimages">
                        <div className="toppertaj">
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/tooperperimg.png"
                            className="img-fluid"
                          />{" "}
                        </div>

                        <LazyLoad
                          offset={10}
                          placeholder={
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/tooperperimg.png"
                              alt="Loading..."
                              className="img-fluid"
                            />
                          }
                        >
                          <img
                            src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments}`}
                            className="img-fluid topprebg"
                          />
                        </LazyLoad>
                        <p className="per">{item.division} </p>
                      </div>
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/tooperpicicn.png"
                        className="img-fluid tooperpicicn"
                      />
                      <div className="topperdesc">
                        <p className="name">
                          {item.name} <span>{item.stream}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                ))
            : emptyArray.map((data, index) => (
                <div className="item">
                  <div className="topperdiv">
                    <div className="topperimages">
                      <div className="toppertaj">
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/tooperperimg.png"
                          className="img-fluid"
                        />{" "}
                      </div>
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/tooper1.jpg"
                        className="img-fluid topprebg"
                      />
                      <p className="per">96.4% </p>
                    </div>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/tooperpicicn.png"
                      className="img-fluid tooperpicicn"
                    />
                    <div className="topperdesc">
                      <p className="name">
                        Student Name <span>District Level 1</span>
                      </p>
                    </div>
                  </div>
                </div>
              ))}
          {/* <div className="item">
<div className="topperdiv">
<div className="topperimages">
<div className="toppertaj"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/tooperperimg.png" className="img-fluid"/> </div>
<p className="per">96.4%</p>
<img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/tooper2.jpg" className="img-fluid topprebg"/>
</div>
<img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/tooperpicicn.png" className="img-fluid tooperpicicn"/>
<div className="topperdesc">

<p className="name">Om Prakash Dwivedi <span>District Level 1</span></p>
</div>
</div>
</div>
<div className="item">
<div className="topperdiv">
<div className="topperimages">
<div className="toppertaj"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/tooperperimg.png" className="img-fluid"/> </div>
<p className="per"> 95.2%</p>
<img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/tooper3.jpg" className="img-fluid topprebg" />

</div>
<img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/tooperpicicn.png" className="img-fluid tooperpicicn"/>
<div className="topperdesc">

<p className="name">Mahak Chaturvedi <span>2 Rank (2023-24)</span></p>
</div>
</div>
</div>
<div className="item">
<div className="topperdiv">
<div className="topperimages">
<div className="toppertaj"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/tooperperimg.png" className="img-fluid"/> </div>
<p className="per">94.8%</p>
<img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/tooper4.jpg" className="img-fluid topprebg"/>

</div>
<img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/tooperpicicn.png" className="img-fluid tooperpicicn"/>
<div className="topperdesc">

<p className="name">Alankrita Singh <span>3 Rank (2023-24)</span></p>
</div>
</div>
</div>
<div className="item">
<div className="topperdiv">
<div className="topperimages">
<div className="toppertaj"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/tooperperimg.png" className="img-fluid"/> </div>
<p className="per"> 96.4%</p>
<img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/tooper1.jpg" className="img-fluid topprebg"/>

</div>
<img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/tooperpicicn.png" className="img-fluid tooperpicicn"/>
<div className="topperdesc">

<p className="name"> Vikram Mishra <span>District Level 1</span></p>
</div>
</div>
</div> */}
        </Slider>
      </div>
    </>
  );
};

export default Topper;
